import { React } from 'react';

const Header = () => {
  return (
    <header>
      <nav className="navbar navbar-dark bg-dark">
        <h1 className="navbar-brand">## Markdown previewer</h1>
      </nav>
    </header>
  )
}
export default Header;